import React from 'react';
import { catalogItems } from '../Catalog';
import './styles.css';

function CatalogPage() {
  return (
    <section className="catalog-page" id="catalog-page">
      <div className="catalog-page-hero">
        <h1>Our Live Catalog</h1>
        <p>
          The same trusted FR Fisheries quality, now in a focused catalog view. Every item below is
          part of our live, fast-moving inventory.
        </p>
      </div>

      <div className="catalog-page-list">
        {catalogItems.map((item, index) => (
          <div key={item.name} className={`catalog-page-row ${index % 2 !== 0 ? 'reverse' : ''}`}>
            <div className="catalog-page-image">
              <img
                src={item.image}
                alt={`Fresh ${item.name} from FR Fisheries`}
                loading="lazy"
                decoding="async"
              />
              <div className="catalog-page-image-overlay" />
              <div className="catalog-page-giant-text">{item.name}</div>
              <div className="catalog-page-name-overlay">
                <h3>{item.name}</h3>
                <span>{item.note}</span>
              </div>
            </div>

            <div className="catalog-page-content">
              <h2 className="catalog-page-heading">{item.name}</h2>
              <p className="catalog-page-sub">{item.note}</p>
              <p>{item.description}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="catalog-page-quote">
        “Live inventory, honest volumes, and seafood curated for serious buyers.”
      </div>
    </section>
  );
}

export default CatalogPage;
